webpackJsonp([263791100135453],{

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.default = PageTitle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PageTitle(_ref) {
	  var children = _ref.children;
	
	  return Glamor.createElement(
	    "h1",
	    {
	      css: {
	        margin: 0
	      }
	    },
	    children
	  );
	}
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Sub;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(21);
	
	var _typography = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Sub(_ref) {
	  var children = _ref.children;
	
	  return Glamor.createElement(
	    "p",
	    {
	      css: _extends({
	        marginBottom: (0, _typography.rhythm)(1 / 2),
	        fontFamily: _typography.headerFontFamily
	      }, (0, _typography.scale)(0.05), {
	        color: _colors.gray50
	      })
	    },
	    children
	  );
	}
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(49);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(71);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _typography = __webpack_require__(10);
	
	var _colors = __webpack_require__(21);
	
	var colors = _interopRequireWildcard(_colors);
	
	var _PageTitle = __webpack_require__(74);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	var _Sub = __webpack_require__(41);
	
	var _Sub2 = _interopRequireDefault(_Sub);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutPage = function (_React$Component) {
	  _inherits(AboutPage, _React$Component);
	
	  function AboutPage() {
	    _classCallCheck(this, AboutPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  AboutPage.prototype.render = function render() {
	    var siteTitle = (0, _get2.default)(this, "props.data.site.siteMetadata.title");
	    var siteAuthor = (0, _get2.default)(this, "props.data.site.siteMetadata.author");
	    var posts = (0, _get2.default)(this, "props.data.allMarkdownRemark.edges");
	
	    return Glamor.createElement(
	      "div",
	      null,
	      Glamor.createElement(_reactHelmet2.default, { title: siteTitle }),
	      Glamor.createElement(
	        _PageTitle2.default,
	        null,
	        siteAuthor
	      ),
	      Glamor.createElement(
	        _Sub2.default,
	        null,
	        "London, United Kingdom"
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "I'm a fan of technology who is always seeking for new stuff to learn, play with, or build real and cool stuff with. I'm currently experimenting and working on frontend code, with Javascript and mainly with React."
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "Also a lover of music, bass guitar player and funny bad jokes teller."
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "I'm currently working at",
	        " ",
	        Glamor.createElement(
	          "a",
	          { href: "http://twitter.com", target: "_blank", rel: "noopener" },
	          "Twitter"
	        ),
	        ", doing cool stuff with Javascript on",
	        " ",
	        Glamor.createElement(
	          "a",
	          { href: "http://tweetdeck.twitter.com", target: "_blank", rel: "noopener" },
	          "TweetDeck"
	        ),
	        ". I'm a lover of open source, you can check my contributions in",
	        " ",
	        Glamor.createElement(
	          "a",
	          { href: "http://github.com/leoasis", target: "_blank", rel: "noopener" },
	          "my Github account"
	        ),
	        "."
	      ),
	      Glamor.createElement(
	        "p",
	        null,
	        "You can contact me via",
	        " ",
	        Glamor.createElement(
	          "a",
	          {
	            target: "_blank",
	            href: "http://twitter.com/leogcrespo",
	            rel: "noopener"
	          },
	          "Twitter"
	        ),
	        " ",
	        "to ask me a question, read some bad jokes (mostly in Spanish), or just to say hi. I would love to chat with you!"
	      )
	    );
	  };
	
	  return AboutPage;
	}(_react2.default.Component);
	
	AboutPage.propTypes = {
	  route: _propTypes2.default.object
	};
	
	exports.default = AboutPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-e1cb6ff837455824a09a.js